<div
    class="input-wrapper"
    [class.light]="light"
    [class.focus]="focus && focusEffect"
    [class.readonly]="readonly"
    #inputContainer>
    <p
        class="input-label"
        [class.show]="(inputValue || focus) && !readonly"
        [class.light]="light"
        [class.focus]="focus && focusEffect">
        {{ label | translate }}
    </p>
    <mat-icon
        class="front-icon"
        [class.show]="frontIcon"
        [svgIcon]="frontIcon"
        [ngStyle]="{
            cursor: readonly ? 'not-allowed' : 'default',
            rotate: frontIconRotate,
        }"></mat-icon>
    <input
        #input
        [disabled]="readonly"
        [type]="type"
        [name]="name"
        [(ngModel)]="inputValue"
        (ngModelChange)="onChange($event)"
        [placeholder]="[inputValue || focus ? (inputValue | translate) : (label | translate)]"
        (focus)="inputFocus()"
        (blur)="inputBlur()"
        (keydown)="inputKeyDown($event)"
        [maxlength]="maxlength"
        [class.light]="light"
        [class.readonly]="readonly"
        data-cy="mimics-settings-tab-input-text-field" />
    <mat-icon
        class="end-icon"
        [class.show]="endIcon"
        [svgIcon]="endIcon"
        (click)="clickIcon()"
        [ngStyle]="{ cursor: readonly ? 'not-allowed' : 'pointer' }"></mat-icon>
    <p class="unit" [class.show]="unit">{{ unit }}</p>
</div>
